/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CallerPermissions model module.
 * @module model/CallerPermissions
 * @version 1.0.0
 */
class CallerPermissions {
    /**
     * Constructs a new <code>CallerPermissions</code>.
     * @alias module:model/CallerPermissions
     */
    constructor() { 
        
        CallerPermissions.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CallerPermissions</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CallerPermissions} obj Optional instance to populate.
     * @return {module:model/CallerPermissions} The populated <code>CallerPermissions</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CallerPermissions();

            if (data.hasOwnProperty('username')) {
                obj['username'] = ApiClient.convertToType(data['username'], 'String');
            }
            if (data.hasOwnProperty('admin')) {
                obj['admin'] = ApiClient.convertToType(data['admin'], 'Boolean');
            }
            if (data.hasOwnProperty('rootPermission')) {
                obj['rootPermission'] = ApiClient.convertToType(data['rootPermission'], 'String');
            }
            if (data.hasOwnProperty('groups')) {
                obj['groups'] = ApiClient.convertToType(data['groups'], ['String']);
            }
            if (data.hasOwnProperty('roles')) {
                obj['roles'] = ApiClient.convertToType(data['roles'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CallerPermissions</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CallerPermissions</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['username'] && !(typeof data['username'] === 'string' || data['username'] instanceof String)) {
            throw new Error("Expected the field `username` to be a primitive type in the JSON string but got " + data['username']);
        }
        // ensure the json data is a string
        if (data['rootPermission'] && !(typeof data['rootPermission'] === 'string' || data['rootPermission'] instanceof String)) {
            throw new Error("Expected the field `rootPermission` to be a primitive type in the JSON string but got " + data['rootPermission']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['groups'])) {
            throw new Error("Expected the field `groups` to be an array in the JSON data but got " + data['groups']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['roles'])) {
            throw new Error("Expected the field `roles` to be an array in the JSON data but got " + data['roles']);
        }

        return true;
    }


}



/**
 * @member {String} username
 */
CallerPermissions.prototype['username'] = undefined;

/**
 * @member {Boolean} admin
 */
CallerPermissions.prototype['admin'] = undefined;

/**
 * @member {module:model/CallerPermissions.RootPermissionEnum} rootPermission
 */
CallerPermissions.prototype['rootPermission'] = undefined;

/**
 * @member {Array.<String>} groups
 */
CallerPermissions.prototype['groups'] = undefined;

/**
 * @member {Array.<String>} roles
 */
CallerPermissions.prototype['roles'] = undefined;





/**
 * Allowed values for the <code>rootPermission</code> property.
 * @enum {String}
 * @readonly
 */
CallerPermissions['RootPermissionEnum'] = {

    /**
     * value: "NONE"
     * @const
     */
    "NONE": "NONE",

    /**
     * value: "VIEW"
     * @const
     */
    "VIEW": "VIEW",

    /**
     * value: "EDIT"
     * @const
     */
    "EDIT": "EDIT",

    /**
     * value: "MANAGE"
     * @const
     */
    "MANAGE": "MANAGE"
};



export default CallerPermissions;

